import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Shell } from "@/components/Shell";
import Splash from "@/pages/Splash";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import Mentors from "@/pages/Mentors";
import MentorProfile from "@/pages/MentorProfile";
import Chat from "@/pages/Chat";
import Play from "@/pages/Play";
import Build from "@/pages/Build";
import Circles from "@/pages/Circles";
import Subscription from "@/pages/Subscription";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-center" />
      <BrowserRouter>
        <Shell>
          <Routes>
            <Route path="/" element={<Splash />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/home" element={<Home />} />
            <Route path="/mentors" element={<Mentors />} />
            <Route path="/mentors/:id" element={<MentorProfile />} />
            <Route path="/chat/:id" element={<Chat />} />
            <Route path="/play" element={<Play />} />
            <Route path="/build" element={<Build />} />
            <Route path="/circles" element={<Circles />} />
            <Route path="/membership" element={<Subscription />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Shell>
      </BrowserRouter>
    </div>
  );
}

export default App;
